<template>
  <div class="M_versionManagement">
    <main>
      <header style="margin-bottom: 20px;">
        <h3>版本管理</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
          <a-button v-if="$IA('system:version:upload')" type="primary" icon="upload" @click="uploadVersion('上传版本')">上传版本
          </a-button>
        </div>
      </header>
      <!-- 表格搜索栏 -->
<!--      <div class="toolbar">-->
<!--      </div>-->
      <!-- 数据表格 -->
      <a-table :columns="tableColumns" bordered :data-source="tableData" :pagination="queryCondition" :loading="tableLoad"
               @change="handleTableChange" :scroll="{ y: 560 }">
        <template slot="versionNumber" slot-scope="text">
          <img src="../../assets/images/versions.png" class="img-lc" alt="" v-if="text" />
          <span :title="text">{{ text }}</span>
        </template>
        <template slot="state" slot-scope="text, record">
          <a-popconfirm
              :title="text == 1 ? '是否禁用该版本?' : '是否启用该版本?' "
              ok-text="确定"
              cancel-text="取消"
              @confirm="switchConfirm"
          >
            <a-switch  @change="onChange($event,record)" :checked="text == 1 ? true : false "  />

          </a-popconfirm>
        </template>
        <span slot="action" slot-scope="record"  class="table-action-box">
           <a-tooltip  content=""  title="修改" v-if="$IA('system:version:update')" placement="top" effect="light">
              <i class="table-edit" @click="handleOpen('修改', record)" ></i>
            </a-tooltip>
               <a-tooltip  content=""  title="下载" v-if="$IA('system:version:download')" placement="top" effect="light">
              <i class="table-download" @click="versionDownload(record)"></i>
            </a-tooltip>
            <a-tooltip  content=""  title="删除" v-if="$IA('system:setting:delete')" placement="top" effect="light">
              <i class="table-delected" @click="handleOpen('删除', record)" ></i>
            </a-tooltip>
        </span>
      </a-table>
    </main>

    <!-- 操作模态框 -->
    <a-modal centered :title="modalTitle == '删除'? '删除版本' : '编辑备注'" :visible="modalVisible" :confirm-loading="btnLoad"
             @ok="handleOk('addForm')" @cancel="resetForm" :confirmLoading="submitLoad"  :maskClosable="false"    :width="modalTitle == '删除' ? '420px' : '520px'">
      <a-form-model v-if="['添加', '修改'].includes(modalTitle)" layout="vertical" :model="addForm" :rules="addFormRules"
                    ref="addForm">
        <a-form-model-item prop="id" v-show="false">
          <a-input v-model="addForm.id" placeholder="请输入" />
        </a-form-model-item>

        <a-form-model-item label="备注" prop="description">
          <a-textarea v-model="addForm.description" placeholder="请输入"  :rows="4" />
        </a-form-model-item>
      </a-form-model>
      <div class="deleteBox" v-if="modalTitle == '删除'">
        <a-icon type="exclamation-circle" theme="filled" />
        <p>此操作将永久删除该版本,是否继续?</p>
      </div>

    </a-modal>


    <!-- 包上传 -->
    <a-modal centered class="upload-modal" :visible="uploadModalVisible" destroyOnClose :confirm-loading="uploadLoad"
             @cancel="fileClose"  :maskClosable="false" :footer="null">

      <template slot="title">
          <span class="el-dialog__title">
            {{uploadModalTitle}}
          </span>
      </template>



      <div class="upload-box">
        <a-upload name="file" :multiple="false" :action="batchImportApi" accept='.zip'
                  :file-list="completeFileList"
                  :showUploadList="false"
                  :headers="{ Authorization: $store.state.user.token }"
                  :before-upload="beforeUpload"
                  @change="handleUpload"
                  >
          <a-button type="primary" :disabled="uploadLoad">
            选择文件
          </a-button>
          <h4 >单次上传文件个数不超过1个</h4>
          <p style="color: #8f8f8f">只支持zip格式</p>
          <a-progress v-if="uploadFolderData.finish"  :percent="uploadFolderData.progress" />
        </a-upload>

      </div>

    </a-modal>


  </div>
</template>

<script>
import JSZip from 'jszip';
import {notification} from "ant-design-vue";
export default {
  data() {
    return {
      btnLoad: false,
      tableLoad: false,
      pagination: {
        searchText: '',
        pageSize: 10,
        pageNo: 1,
        orgId:undefined,
        current: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      tableColumns: [
        {
          title: '版本',
          dataIndex: 'versionNumber',
          key: 'versionNumber',
          ellipsis: true,
          scopedSlots: { customRender: "versionNumber" },
        },
        {
          title: '创建人',
          dataIndex: 'userName',
          key: 'userName',
          ellipsis: true,
        },
        {
          title: '状态',
          dataIndex: 'state',
          key: 'state',
          ellipsis: true,
          scopedSlots: { customRender: "state" },
        },
        {
          title: '备注',
          dataIndex: 'description',
          key: 'description',
          ellipsis: true,
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: "action" },
        },
      ],
      formLayout:"inline",
      queryCondition:{},
      tableData: [],
      //部门下拉框
      orgList:{},
      // 模态框显隐
      modalVisible: false,
      relationRobotVisible: false,
      // 模态框标题
      modalTitle: '',
      // 单行数据
      singleDta: "",
      // 是否按钮loading
      submitLoad: false,
      // 添加/修改保存API
      saveApi: "",
      // 添加表单
      addForm: {
        id: "",
        description: "",
        versionNumber:''
      },
      addFormRules: {
        description: [{ required: false, max: 2000, message: '备注最长不能超过2000字符' }]
      },

      // 监听获取
      selectedKeys: [],
      // 分页参数
      pagCurrent:{},


      // 关联
      typeNameList:{
        0:'无人值守',
        1:'有人值守',
      },
      relPagination:{
        id:'',
        searchText: '',
        type:undefined,
        pageSize: 10,
        pageNo: 1,
        current: 1,
        total: 0,
        showQuickJumper: false,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
      },

      reQueryCondition:{},
      rePagCurrent:'',
      reTableData: [],
      selectedJobRowKeys:[],
      associationLoad:false,
      environmentId:"",
      // 开关
      activityChecked:false,
      activityData:{},

      // 上传
      uploadModalTitle:'',
      uploadLoad:false,
      uploadModalVisible:false,
      // 文件列表
      completeFileList:[],
      // 上传列表
      defaultFileList:[],
      batchImportApi: "/willingbotpackage/upload",
      // 判断是否可上传
      uploadBtn:true,
      // 进度条显示
      uploadFolderData:{
        progress: 0,
        finish: false,
     },
      // 文件上传中止
      uploadCancelToken:[],
      // 判断文件是否上传成功
      isTheUploadSuccessful:false
    }
  },
  methods: {
    // 重置表单通用方法
    resetForm() {
      if (this.modalTitle == '添加' || this.modalTitle == '修改') {
        this.$refs.addForm.resetFields()
      }
      this.modalVisible = false
    },
    // 重置搜索
    resetSearch() {
      this.$refs.searchBar.resetFields()
      this.searchChange()
    },
    // 关联 重置搜索
    reResetForm(){
      this.$refs.relPagination.resetFields();
      this.relationRobotVisible = false;
    },
    // 表格字段 气泡确认框
    switchConfirm(){
      if (this.activityChecked) {
        this.switchChange(this.activityData,'/willingbotpackage/enable')
      }else{
        this.switchChange(this.activityData,'/willingbotpackage/disable')
      }
    },
    // 下载
    versionDownload(data){
      let url=this.axios.defaults.baseURL + '/willingbotpackage/download' + '?token=' + this.$store.state.user.token + '&id=' + data.id
      window.open(url)
    },
    switchChange(data,api){
      this.axios
          .post(api,{id:data.id,versionNumber:data.versionNumber})
          .then((res) => {
            if (res.code == 200) {
              this.handleTableChange(this.pagCurrent);
              notification.success({
                message: res.message,
                duration: 3,
                customClass: "batch-import",
              })
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 表格 活动监听字段更新
    onChange(checked,record) {
      this.activityChecked = checked
      this.activityData = record
    },

    // 上传版本
    uploadVersion(title){
      this.uploadModalTitle = title
      this.uploadLoad = false
      this.uploadModalVisible = true
    },

    // 选择文件上传
    beforeUpload(file) {
      this.completeFileList = [...this.completeFileList,  file];
      //限制文件只能上传一个
      this.completeFileList = this.completeFileList.slice(-1);
      this.uploadCancelToken = this.axios.CancelToken.source()
      if (file.type !='application/x-zip-compressed') {
        this.$message.warning('仅支持zip格式文件上传');
        this.uploadLoad = false
        this.uploadCancelToken.cancel(
            '取消'
        );
        this.uploadBtn = false
        this.uploadFolderData.finish = false
      }else{
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const zip = new JSZip();
          let zipJudge = []
          zip.loadAsync(data).then((zip) => {
            // 遍历zip文件内容
            zip.forEach((relativePath, zipEntry) => {
              if (relativePath.split('.').slice(-1)[0] == 'json'  &&  !zipJudge.includes('json')){
                zipJudge.push('json')
              }
              if (relativePath.split('.').slice(-1)[0] == 'exe'  &&  !zipJudge.includes('exe')){
                zipJudge.push('exe')
              }
              if (relativePath.split('.').slice(-1)[0] == 'txt'  &&  !zipJudge.includes('txt')){
                zipJudge.push('txt')
              }
            });
            if (zipJudge.includes('txt') && zipJudge.includes('exe') && zipJudge.includes('json')){
              this.uploadBtn = true
              this.uploadLoad = true
            }else{
              this.uploadBtn = false
              this.$message.warning('文件缺失内容，请检查');
              this.uploadLoad = false
              this.completeFileList = []
              this.uploadCancelToken.cancel(
                  '取消'
              );
            }
          });
        };
        reader.readAsArrayBuffer(file);

      }
      return false


    },
    handleUpload(info) {
      setTimeout(()=>{
        if (this.uploadBtn){
          const { completeFileList } = this;
          const formData = new FormData();
          completeFileList.forEach(file => {
            formData.append('file', file);
          });
          this.uploadFolderData.finish = true
          this.isTheUploadSuccessful = true
          this.uploadLoad = true
          this.axios
              .post(this.batchImportApi, formData,{
                // 取消传输超时限制
                timeout: 0,
                cancelToken: this.uploadCancelToken.token,
                // `onUploadProgress` 允许为上传处理进度事件
                onUploadProgress: (progressEvent) => {
                  // 对原生进度事件的处理
                  // console.log(progressEvent);
                  let percent = ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2);
                  this.uploadFolderData.progress = Number(percent);
                },
              })
              .then((res) => {
                if (res.code == 200) {
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                }
                this.completeFileList = [];
                this.uploadLoad = false
                this.isTheUploadSuccessful = false
              })
              .catch((err) => {
                console.log(err);
              });
        }

      },100)
    },


    // 清空文件夹退出
    fileClose() {
      this.completeFileList = []
      this.uploadModalVisible = false
      if (this.isTheUploadSuccessful){
        this.uploadCancelToken.cancel(
            '取消'
        );
        this.$message.warning('已终止文件上传');
      }
      this.uploadLoad = false
      this.uploadFolderData.progress = 0
      this.uploadFolderData.finish = false
      this.isTheUploadSuccessful = false

      this.handleTableChange(this.pagination)
    },
    // 打开模态框
    handleOpen(title, data) {
      this.modalTitle = title
      this.modalVisible = true
      this.$nextTick(() => {
        this.singleDta = data
        switch (title) {
          case '修改':
            this.saveApi = '/willingbotpackage/update'
            this.addForm = this.$lodash.pick(
                this.singleDta,
                this.$lodash.keys(this.addForm)
            );
            break;
          case '删除':

            break;
        }
      })
    },
    // 确认模态框
    handleOk(formName) {
      if (this.modalTitle == "添加" || this.modalTitle == "修改") {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submitLoad = true;
            let saveData = "";
            saveData = this.$lodash.cloneDeep(this.addForm);
            this.axios
                .post(this.saveApi, saveData)
                .then((res) => {
                  this.submitLoad = false;
                  if (res.code === 200) {
                    notification.success({
                      message: res.message,
                      duration: 3,
                      customClass: "batch-import",
                    })
                    this.handleTableChange(this.modalTitle == "添加"? this.pagination:this.pagCurrent);
                    this.resetForm()
                  }
                })
                .catch((err) => {
                  this.submitLoad = false;
                  console.log(err);
                });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        this.submitLoad = true;
        this.axios
            .delete("/willingbotpackage/delete?id=" + this.singleDta.id)
            .then((res) => {
              this.submitLoad = false;
              if (res.code === 200) {
                notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
                this.handleTableChange(this.pagCurrent);
                this.modalVisible = false;
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
      }
    },
    // 部门下拉框
    allorgList() {
      this.axios
          .post("/org/findParentOrg",'')
          .then((res) => {
            if (res.code === 200) {
              this.orgList = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    // 监听搜索输入框输入
    searchTextChange(val) {
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo =  pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination:this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax() {
      this.tableLoad = true
      this.axios.post('/willingbotpackage/findPage', this.$qs.stringify(this.queryCondition)).then((res) => {
        this.tableLoad = false
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.queryCondition.total = res.data.total;
        }
      }).catch((err) => {
        console.log(err);
        this.tableLoad = false
      })
    },
  },
  beforeMount() {
    this.searchChange()
    this.allorgList()
  }
}
</script>

<style lang="scss" scoped>
.M_versionManagement {
  .ant-transfer {
    width: 1000px;
  }

  main {
    margin-top: 16px;
    background-color: #fff;
    border-radius: 2px;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }

    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }
    .img-lc {
      vertical-align: middle;
      margin: -2px 5px 0px 5px;
    }


  }


}
.upload-modal{
 ::v-deep  .ant-modal-body{
    padding-bottom:20px;
  }
}
.upload-box{
    text-align: center;
    border: 1px #dbe1e6 dashed ;
    padding: 20px;
   .ant-upload{
    .ant-btn {
      margin-top: 10px;
    }
    h4{
      margin-top: 10px;
      font-weight: 600;
      color: #120f07;
    }
    p{
      margin-top: 10px;
    }

     .ant-progress-line{
       width: 450px;
       margin-top: 10px;
       margin: 10px 0 0 -10px;
     }
  }
  //.ant-upload{
  //  margin-top: 10px;
  //}
  //h4{
  //  margin-top: 20px;
  //  font-weight: 600;
  //  color: #120f07;
  //}
  //p{
  //  margin-top: 10px;
  //}
}
</style>